// lang/en.js
export default {
    copySuccess: '复制成功',
    copyFail: '复制失败，请尝试手动复制',
    foot: {
        termsOfService: '会员条款',
        privacyPolicy: '隐私条款',
        Notice: '注意事项',
        EmailText: '客服邮箱：',
        info: '© NEXON Korea Corp.All Rights Reserved',
        info1: '',
        info2: '',
        info3: '',
        info4: ''
    },
    notFound: {
        title: '您访问的页面不见了......',
        content: '即将离开本页，',
        content2: ' 秒后自动返回首页',
        btn: '返回首页',
    }
};